import * as React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

export default function Divider() {
  return (
    <Container>
      <Row>
        <Col>
          <hr />
        </Col>
      </Row>
    </Container>
  );
}
